import { useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../../components/PdfZipItem";

const CorporateGovernanceUpdate = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const {
    data: corporateGovernanceUpdateData = [],
    isLoading: corporateGovernanceUpdateIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "corporate_governance_updates",
    lang: languageType,
  });

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(corporateGovernanceUpdateData);
  }, [corporateGovernanceUpdateData]);

  useTableResponsive(corporateGovernanceUpdateData);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (corporateGovernanceUpdateIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Investors", "निवेशक")}
        titleLink="/investors/corporate-governance-updates"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("Downloads", "डाउनलोड")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {corporateGovernanceUpdateData.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Description", "विवरण")}>
                            <div
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            ></div>
                          </td>
                          <td data-key={getText("Downloads", "डाउनलोड")}>
                            {item.field_download ? (
                              <PdfZipItem
                                filePath={item?.field_download}
                                filesize={item?.filesize}
                              />
                            ) : (
                              <>
                                <a
                                  href={item.field_extenral_link}
                                  target="_blank"
                                >
                                  More
                                </a>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CorporateGovernanceUpdate;
